import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { CoreModule } from "src/app/core/core.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { LearnQuestionAnswer } from "./learn-question-answer.component";
import { FlashcardComponent } from "./flashcard/flashcard.component";
import { FeedbackWidgetComponent } from "./feedback-widget/feedback-widget.component";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  declarations: [
    LearnQuestionAnswer,
    FlashcardComponent,
    FeedbackWidgetComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    FormsModule,
    SharedModule,
    CoreModule,
    TranslateModule
],
  exports: [
    LearnQuestionAnswer,
    FlashcardComponent,
    FeedbackWidgetComponent
  ]
})
export class LearnQuestionAnswerModule { }